import { HTTP } from '../services';

export default new class ProposalService {
  /**
   * Fetch venue contact info and email template for the given venue IDs.
   * @param {number[]} venueIds
   * @param {number} leadEventId
   */
  getProposalInfo(venueIds, leadEventId) {
    return HTTP.get(`/v1/lead-event/${leadEventId}/proposals/info`, {
      params: {
        venue_ids: venueIds,
      },
    });
  }

  sendProposal(leadEventId, formData) {
    return HTTP.post(`/v1/lead-event/${leadEventId}/proposals`, formData);
  }
}
